import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4bc712af"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tips-modal-header" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-x-lg" }, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "tips-modal-content" }
const _hoisted_5 = { class: "tips-section text-muted" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-lightbulb" }),
  /*#__PURE__*/_createTextVNode(" Why It's Important")
], -1))
const _hoisted_7 = { class: "text-start" }
const _hoisted_8 = { class: "tips-section" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-check2-circle" }),
  /*#__PURE__*/_createTextVNode(" How to Add It")
], -1))
const _hoisted_10 = { class: "action-section mt-4" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "courses-title" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-book" }),
  /*#__PURE__*/_createTextVNode(" Relevant Free Courses")
], -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "courses-description" }, " Explore hand-picked educational resources curated by JobBuddy to enhance your skills. ", -1))
const _hoisted_13 = { class: "action-box p-3 mt-2 border rounded" }
const _hoisted_14 = ["href"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-arrow-right" }, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "resume-title" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-file-earmark-text" }),
  /*#__PURE__*/_createTextVNode(" Update Your Resume ")
], -1))
const _hoisted_17 = { class: "resume-description" }
const _hoisted_18 = { class: "action-box p-3 mt-2 border rounded" }
const _hoisted_19 = ["href"]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Optimize Your Resume", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-arrow-right" }, null, -1))
const _hoisted_22 = [
  _hoisted_20,
  _hoisted_21
]

import { useRoute } from "vue-router";

interface Resource {
  title: string;
  url: string;
  type?: string;
  suggestedCourses?: string;
}

interface Props {
  isOpen: boolean;
  title: string;
  importance: string;
  tips: string[];
  resources: Resource[];
  type: string;
  user?: {
    id?: number;
    name?: string;
    email?: string;
  };
}

declare global {
  interface Window {
    jivo_onMessageSent: () => void;
    jivo_api: {
      setCustomData: (data: Array<{ key: string; content: string }>) => void;
    };
  }
}

// Get user data from props or store

export default /*#__PURE__*/_defineComponent({
  __name: 'TipsModal',
  props: {
    isOpen: { type: Boolean },
    title: {},
    importance: {},
    tips: {},
    resources: {},
    type: {},
    user: {}
  },
  emits: ["close"],
  setup(__props: any, { emit: __emit }) {

const route = useRoute();
const props = __props;
const emit = __emit;

const closeModal = () => {
  emit("close");
};

// Declare the Jivo callback function globally
const sendUserDataToJivo = () => {
  const userData = [
    { key: "name", content: props.user?.name || "" },
    { key: "email", content: props.user?.email || "" },
    { key: "id", content: props.user?.id?.toString() || "" },
  ];

  window.jivo_api.setCustomData(userData);
};

// Set up the Jivo callback
window.jivo_onMessageSent = () => {
  console.log("Client sent the first message");
  if (props.user) {
    sendUserDataToJivo();
  }
};

return (_ctx: any,_cache: any) => {
  return (_ctx.isOpen)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "tips-modal-overlay",
        onClick: closeModal
      }, [
        _createElementVNode("div", {
          class: "tips-modal",
          onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
        }, [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("h3", null, _toDisplayString(_ctx.title), 1),
            _createElementVNode("button", {
              class: "close-button",
              onClick: closeModal
            }, _hoisted_3)
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.importance), 1)
            ]),
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _createElementVNode("ul", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tips, (tip, index) => {
                  return (_openBlock(), _createElementBlock("li", {
                    class: "tip-item text-muted",
                    key: index
                  }, _toDisplayString(tip), 1))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_10, [
                (props.resources?.length > 0)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _hoisted_11,
                      _hoisted_12,
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("a", {
                          href: `/courses?category=${encodeURIComponent(
                    props.resources?.[0]?.type || _ctx.title
                  )}`,
                          target: "_blank",
                          rel: "noopener noreferrer",
                          class: "text-decoration-none d-flex justify-content-between align-items-center"
                        }, [
                          _createElementVNode("span", null, "View Free " + _toDisplayString(_ctx.title) + " Courses", 1),
                          _hoisted_15
                        ], 8, _hoisted_14)
                      ])
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _hoisted_16,
                      _createElementVNode("p", _hoisted_17, " Let's optimize your resume to better highlight your " + _toDisplayString(props.type === "keyword" ? "relevant keywords" : "experience") + ". ", 1),
                      _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("a", {
                          href: `/documents/new/${
                    _unref(route).params.id
                  }?type=resume&highlight=${encodeURIComponent(_ctx.title)}`,
                          target: "_blank",
                          rel: "noopener noreferrer",
                          class: "text-decoration-none d-flex justify-content-between align-items-center"
                        }, _hoisted_22, 8, _hoisted_19)
                      ])
                    ], 64))
              ])
            ])
          ]),
          _createElementVNode("div", { class: "tips-modal-footer" }, [
            _createElementVNode("button", {
              class: "primary-button",
              onClick: closeModal
            }, "Got it!")
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})